<template>
  <div class="tag-editor">
    <div class="tags">
      <span v-for="(tag, idx) in modelValue" :key="idx" class="tag-editable">
        #{{ tag }}
        <button class="tag-remove" @click="remove(idx)" aria-label="Remove tag">×</button>
      </span>
      <button class="tag-add-btn" @click="promptAdd">+ Add Tag</button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  max: { type: Number, default: 0 }
});
const emit = defineEmits(['update:modelValue', 'tag-added', 'tag-removed']);

function normalize(tag) {
  return (tag || '').trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
}

function set(tags) {
  emit('update:modelValue', [...tags]);
}

function promptAdd() {
  if (props.max && props.modelValue.length >= props.max) return;
  const input = window.prompt('Enter a new tag (without #):');
  const clean = normalize(input);
  if (!clean) return;
  if (props.modelValue.includes(clean)) return;
  const updated = [...props.modelValue, clean];
  set(updated);
  emit('tag-added', clean);
}

function remove(idx) {
  const removed = props.modelValue[idx];
  const updated = props.modelValue.slice(0, idx).concat(props.modelValue.slice(idx + 1));
  set(updated);
  emit('tag-removed', removed);
}
</script>

<style scoped>
.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
.tag-editable {
  background: rgba(76, 175, 80, 0.2);
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid rgba(76, 175, 80, 0.3);
}
.tag-remove {
  background: none;
  border: none;
  color: #ff6b6b;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.tag-remove:hover { background: rgba(255, 107, 107, 0.2); }
.tag-add-btn {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.2) 0%, rgba(76, 175, 80, 0.1) 100%);
  border: 1px solid rgba(76, 175, 80, 0.3);
  border-radius: 12px;
  color: #4CAF50;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 12px;
}
</style>
